//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgPending } from '../icons/Pending';

export function PendingIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgPending} data-qa="PendingIcon">
      <svg />
    </SvgIcon>
  );
}
